<template>
    <v-dialog v-model="dialog" width="800px">
        <v-card>
            <v-card-title class="justify-center">Actions for lead {{ pten_code }}</v-card-title>
            <v-divider></v-divider>
            <v-card-text>
                <div class="text-scroll">
                    <div v-html="convertTextToHtml(text)"></div>
                </div>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" small @click="closeDialog">Close</v-btn>
            </v-card-actions>
        </v-card> 
    </v-dialog>
</template>

<script>
    export default {
        components: {
        },
        props: {
        },
        data() {
            return {
                dialog: false,
                pten_code: "",
                text: "",
            }
        },
        methods: { 
            openDialog(pten_code, text) {
                this.pten_code = pten_code;
                this.text = text;
                this.dialog = true;
            },
            closeDialog() {
                this.dialog = false;
            },
            convertTextToHtml(text) {
                return text.replace(/\n/gi, '<br>'); // yes indeed, regular expression!!
            },
        }
    }
</script>


<style scoped>
    .text-scroll {
        height: calc(100vh - 325px);
        overflow-y: auto;
    }
</style>